import { apiJWT } from "api/api-jwt";

export class ExtratoEndpoints {
  public static async getExtratos(page: number, size = 10) {
    const { data } = await apiJWT.get<ExtratoRow[]>(
      `/extratos-online/find-all`,
      { params: { page, size } },
    );
    return data;
  }

  public static async createExtrato(beneficio: string) {
    const { data } = await apiJWT.post(
      `/extratos-online?beneficio=${beneficio}`,
    );
    return data;
  }

  public static async getExtratoPDF(hash: string) {
    const { data } = await apiJWT.get<string>(
      `/extratos-online/pdf?hash=${hash}`,
    );
    return data;
  }
}

export interface ExtratoRow {
  id: number;
  beneficio: string;
  dataCriacao: string;
  customerId: number;
  userId: number;
  userUsername: string;
  hash: string;
  jsonContent: any | null;
  carteiraItemId: number;
  json: ExtratoData;
}

interface ExtratoData {
  dados: {
    beneficio: number;
    nome: string;
    especie: {
      codigo: number;
      descricao: string;
    };
    situacao: string;
    bloqueioEmprestismo: boolean;
    elegivelEmprestimo: boolean;
    possuiProcurador: boolean;
    possuiRepresentante: boolean;
    pensaoAlimenticia: boolean;
    meioPagamento: string;
    banco: {
      codigo: number;
      descricao: string;
    };
    agencia: string;
    conta: string;
    valorBase: number;
    margemConsignavel: number;
    margemDisponivelEmprestimo: number;
    margemUtilizadaEmprestimo: number;
    margemDisponivelRMC: number;
    margemReservadaRMC: number;
    margemDisponivelRCC: number;
    margemReservadaRCC: number;
  };
  contratosEmprestimo: Array<{
    contrato: string;
    tipoEmprestimo: string;
    banco: {
      codigo: number;
      descricao: string;
    };
    dataInclusao: string;
    competenciaInicioDesconto: string;
    competenciaFimDesconto: string;
    situacao: string;
    quantidadeParcelas: number;
    valorEmprestado: number;
    valorLiberado: number;
    valorParcela: number;
  }>;
  contratosRMC: Array<{
    contrato: string;
    tipoEmprestimo: string;
    banco: {
      codigo: number;
      descricao: string;
    };
    dataInclusao: string;
    situacao: string;
    valorLimiteCartao: number;
    valorReservado: number;
  }>;
  contratosRCC: Array<any>;
}
